module.exports = __webpack_public_path__ + "static/media/ptl-ambass-faq-img.34531d88.jpg";